export default __webpack_public_path__ + "static/media/bg6.e1a01f85.jpg";